<template>
  <div class="password-input" :class="$attrs.class">
    <input
      class="password-input__field"
      :type="visible ? 'text' : 'password'"
      :value="modelValue"
      :placeholder="placeholder"
      :disabled="disabled"
      :required="required"
      :autocomplete="autocomplete"
      :minlength="minlength"
      @input="onInput"
    />
    <button
      type="button"
      class="password-input__toggle"
      :disabled="disabled"
      :title="visible ? 'Скрыть пароль' : 'Показать пароль'"
      :aria-label="visible ? 'Скрыть пароль' : 'Показать пароль'"
      :aria-pressed="visible"
      tabindex="-1"
      @click="visible = !visible"
    >
      <i :class="visible ? 'fa-regular fa-eye-slash' : 'fa-regular fa-eye'" aria-hidden="true" />
    </button>
  </div>
</template>

<script setup>
import { ref } from 'vue'

defineOptions({ inheritAttrs: false })

defineProps({
  modelValue: { type: String, default: '' },
  placeholder: { type: String, default: 'Пароль' },
  disabled: { type: Boolean, default: false },
  required: { type: Boolean, default: false },
  autocomplete: { type: String, default: 'current-password' },
  minlength: { type: [String, Number], default: undefined },
})

const emit = defineEmits(['update:modelValue'])

const visible = ref(false)

function onInput(event) {
  emit('update:modelValue', event.target.value)
}
</script>

<style scoped>
.password-input {
  display: flex;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  min-height: 0;
}

.password-input__field {
  flex: 1;
  min-width: 0;
  margin: 0;
  border: none;
  background: transparent;
  color: inherit;
  font: inherit;
  font-size: 1rem;
  line-height: 1.25;
  outline: none;
  box-shadow: none;
  height: auto;
  min-height: 0;
}

.password-input__field:disabled {
  cursor: not-allowed;
}

.password-input__toggle {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  align-self: stretch;
  margin: 0;
  padding: 0 0.75rem;
  border: none;
  background: transparent;
  color: #515154;
  cursor: pointer;
  line-height: 1;
  font-size: 1rem;
}

.password-input__toggle i {
  font-size: 1rem;
  line-height: 1;
}

.password-input__toggle:hover:not(:disabled) {
  color: #1d1d1f;
}

.password-input__toggle:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.password-input__toggle:focus-visible {
  outline: 2px solid #0071e3;
  outline-offset: 2px;
  border-radius: 4px;
}

/* Воронка: padding только у поля, не у обёртки (см. .lead-funnel__input.password-input) */
.password-input.lead-funnel__input .password-input__field {
  padding: 0.78rem 0.5rem 0.78rem 0.95rem;
}

.password-input.lead-funnel__input .password-input__field::placeholder {
  color: #86868b;
}
</style>
